import { FileTextOutlined } from '@ant-design/icons';
import { RichiestaModuloDTO } from '@framework/api-client';
import { t } from '@framework/i18n';
import React from 'react';
import { getModuleTitle } from '../../module/getModuleTitle';
import { SubmissionMenuItemType } from '../menu/ISubmissionMenuItem';
import { mapSubmissionModuleState } from '../state/mapSubmissionModuleState';
import { IGetSubmissionMenuLink } from './getSubmissionMenuItemLink';
import {
  getModuleKey,
  getSectionsMenuItems,
} from './getSubmissionModuleMenuItems';

/**
 * Ritorna la struttura dei menu items per i moduli secondari e dinamici.
 */
export function buildModuleMenuItems(params: {
  module: RichiestaModuloDTO;
  getMenuLink: IGetSubmissionMenuLink;
  submissionId: string;
  isSent: boolean;
}) {
  const { module, getMenuLink, submissionId, isSent } = params;
  const moduleTitle = getModuleTitle(module);

  return {
    key: getModuleKey(module),
    index: getModuleKey(module),
    name:
      moduleTitle ??
      t('submission-menu-items.altro-modulo', 'Altro Modulo'),
    type: SubmissionMenuItemType.Module,
    icon: <FileTextOutlined aria-hidden />,
    context: {
      submissionModuleId: module.id,
      validationState: module.statoValidazione,
      state: mapSubmissionModuleState(module.statoCompilazione),
    },
    children: getSectionsMenuItems({
      sections: module.modulo?.sezioni,
      module,
      getMenuLink,
      submissionId,
      isSent,
      // Se esistono moduli secondari, esistono per forza più moduli e non è richiesto nascondere le sezioni
      hideSectionIfSingle: false,
    }),
    to: getMenuLink({
      submissionId,
      type: 'module',
      module,
      options: { isSent },
    }),
  };
}
